import React from 'react';
import LoginContainer from './LoginContainer';
import LoginBubble from './LoginBubble';

const LoginBubbleContainer = props => (
	<LoginContainer>
		{sharedProps => <LoginBubble {...props} {...sharedProps} />}
	</LoginContainer>
);

export default LoginBubbleContainer;
